import React from 'react';
import { CTAButton } from './CTAButton';
interface FinalCTASectionProps {
  onCtaClick: () => void;
}
export function FinalCTASection({
  onCtaClick
}: FinalCTASectionProps) {
  return <section className="py-24 px-4 bg-brand-green text-center" data-id="element-54" data-mp="3s2fq57afb2ek">
      <div className="max-w-3xl mx-auto" data-id="element-55" data-mp="3s03a4zo87245">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-10 text-balance" data-id="element-56" data-mp="wek5d5beyzs">
          ¿Estás lista para recuperar tu tiempo?
        </h2>
        <CTAButton variant="terracotta" onClick={onCtaClick} className="text-base md:text-lg py-5 px-10" data-id="element-57" data-mp="2zfbptfm9zc94">
          Quiero el Kit Yoga Lista
        </CTAButton>
      </div>
    </section>;
}